import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { supportedSizes, squareOfSize } from '../../../utilities/tailwindClassHelpers'

function LoadingSpinner({ className = '', size = '4', color = 'purple' }) {
  function colorClass() {
    switch (color) {
      case 'red':
        return 'text-red-800'
      case 'purple':
        return 'text-purple-800'
      case 'yellow':
        return 'text-yellow-500'
      case 'teal':
        return 'text-teal-800'
      case 'pink':
        return 'text-pink-800'
      case 'blue':
        return 'text-blue-800'
      case 'green':
        return 'text-green-700'
      case 'orange':
        return 'text-orange-800'
      case 'white':
        return 'text-white'
      case 'black':
        return 'text-black'
      default:
        return 'purple'
    }
  }

  return (
    <span className={className}>
      <svg
        className={classNames('animate-spin inline', colorClass(), squareOfSize(size))}
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        style={{ animationDuration: '0.6s', maxWidth: '100px', maxHeight: '100px' }}
      >
        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
        <circle
          cx="12"
          cy="12"
          r="10"
          stroke="currentColor"
          strokeWidth="3"
          strokeLinecap="round"
          strokeDasharray="15 47"
          fill="none"
        />
      </svg>
    </span>
  )
}

LoadingSpinner.propTypes = {
  className: PropTypes.string,
  color: PropTypes.oneOf(['red', 'purple', 'yellow', 'teal', 'pink', 'blue', 'green', 'orange', 'white', 'black']),
  size: PropTypes.oneOf(supportedSizes)
}

export default LoadingSpinner
